export class Pager {

    constructor(public readonly page: number,
                public readonly offset: number,
    ) {}

}

export type TYMD = {
    year: number,
    month: number,
    day: number,
}


// WEBPACK FOOTER //
// ./src/domain/model/common.ts